module.exports = __webpack_public_path__ + "img/undraw-product_tour.0bc51b23.png";